export const getSocketToken = () => ({
  url: `/profile/socket`,
  method: 'get',
});
